import React from "react";

import "../style/footer.css"

function Footer() {
    return (
        <div className="footer-container">
            <div className="separator">
                <b>Soluções educacionais</b>
                <a href="#">Livros</a>
                <a href="#">Literatura</a>
                <a href="#">Aprendizagem Digital</a>
                <a href="#">Formação de educadores</a>
                <a href="#">Sistemas de Ensino</a>
            </div>

            <div className="separator">
                <b>Institucional</b>
                <a href="#">Divulgação Responsável</a>
                <a href="#">Premiações</a>
                <a href="#">Trabalhe conosco</a>
                <a href="#">Parcerias e inovação</a>
                <a href="#">Blog</a>
            </div>

            <div className="separator">
                <b>Central de relacionamento</b>
                <a href="tel:+5511997170947">Ligue: (11) 99717-0947</a>
                <span>Das 8h ás 18h - Seg a sex</span>
            </div>

            <div className="separator">
                <b>Acesse</b>
                <a href="#">Contato</a>
                <a href="#">Política de Privacidade</a>
                <a href="#">Termos de uso</a>
                <a href="#">Gerenciar cookies</a>
            </div>
        </div>
    )
}

export default Footer